hrd.GlobalDeferredWrapper = Class.extend({
	init: function() {
		this.deferred = $.Deferred();
	},
	resolve: function(result) {
		this.deferred.resolve(result);
	},
	reject: function(reason) {
		this.deferred.reject(reason);
	},
	promise: function() {
		return this.deferred.promise();
	}
});

window['dashboardReady'] = new hrd.GlobalDeferredWrapper();
window['whenDashboardIsReady'] = dashboardReady.promise();